export default "__VITE_ASSET__BQXpoe$K__"